import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcesses(agro_exporter_id) {
    return RequesterV1.get(
      `agro_exporter/finances/harvested_batch_outcomes/${agro_exporter_id}/list_processes`
    );
  }
};
